import { Controller } from '@hotwired/stimulus';

/**
 * インライン編集機能（表示とフォームの切り替え）を制御するStimulusコントローラ
 * @extends Controller
 */
export default class extends Controller {
  static targets = [ 'display', 'form', 'formElement', 'emailInput' ];
  static values = { confirmMessage: String };

  /**
   * 「変更」ボタンがクリックされた時のアクション
   */
  showForm() {
    this.displayTarget.classList.add('d-none');
    this.formTarget.classList.remove('d-none');
  }

  /**
   * 「キャンセル」ボタンがクリックされた時のアクション
   */
  hideForm() {
    this.displayTarget.classList.remove('d-none');
    this.formTarget.classList.add('d-none');
    this.formElementTarget.reset();
  }

  /**
   * フォームのsubmitイベントを検知して実行される
   * @param {Event} event - フォームのsubmitイベント
   */
  confirm(event) {
    // デフォルトのフォーム送信を一旦停止
    event.preventDefault();

    // 入力された新しいメールアドレスを取得
    const newEmail = this.emailInputTarget.value;
    // data属性からメッセージのテンプレートを取得し、メールアドレスを埋め込む
    const message = this.confirmMessageValue.replace('{email}', newEmail);

    // 作成した動的なメッセージで確認ダイアログを表示
    if (window.confirm(message)) {
      // 「OK」が押されたら、フォームを送信する
      this.formElementTarget.submit();
    }
  }
}
